import IconDetail from "@/components/common/IconDetail";
import type { SurgeryViewT } from "@/types/database/events";
import {
	ArrowLeftRight,
	Crosshair,
	Hammer,
	User,
	UserSquare,
} from "lucide-react";

interface Props {
	surgery: SurgeryViewT;
}
const SurgerySummary = ({ surgery }: Props) => {
	return (
		<div className="space-y-1 text-sm">
			<IconDetail
				icon={<UserSquare size={16} />}
				words={`Referred by: ${
					surgery?.referring_clinician_name ?? "Unknown"
				}`}
			/>
			<IconDetail
				icon={<User size={16} />}
				words={`Performed by: ${
					surgery?.operating_clinician_name ?? "Unknown"
				}`}
			/>
			<IconDetail
				icon={<ArrowLeftRight size={16} />}
				words={surgery.side ?? "NA"}
			/>
			<IconDetail
				icon={<Crosshair size={16} />}
				words={surgery.orthopaedic_area ?? "NA"}
			/>
			<IconDetail
				icon={<Hammer size={16} />}
				words={surgery.surgery_name}
			/>
		</div>
	);
};

export default SurgerySummary;
